import React, { forwardRef } from 'react';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

const StyledTextarea = styled(BaseTextareaAutosize)(({ theme }) => ({
    boxSizing: 'border-box',
    //width: '320px',
    fontFamily: 'IBM Plex Sans, sans-serif',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
    padding: '8px 12px',
    borderRadius: 8,
    color: theme.palette.mode === 'dark' ? '#C7D0DD' : '#1C2025',
    background: theme.palette.mode === 'dark' ? '#1C2025' : '#fff',
    border: `1px solid ${
        theme.palette.mode === 'dark' ? '#434D5B' : '#DAE2ED'
    }`,
    boxShadow: `0px 2px 2px ${
        theme.palette.mode === 'dark' ? '#1C2025' : '#F3F6F9'
    }`,
    '&:hover': {
        borderColor: '#3399FF',
    },
    '&:focus': {
        borderColor: '#3399FF',
        boxShadow: `0 0 0 3px ${
            theme.palette.mode === 'dark' ? '#0072E5' : '#b6daff'
        }`,
    },
    '&:focus-visible': {
        outline: 0,
    },
    '&:disabled': {
        //backgroundColor: theme.palette.mode === 'dark' ? '#2C2F34' : '#F3F6F9',
        //color: theme.palette.text.disabled,
        cursor: 'not-allowed',
        borderColor: theme.palette.mode === 'dark' ? '#555A63' : '#E0E0E0',
        boxShadow: 'none',
    },
}));

const TextArea = forwardRef(function TextArea(props, ref) {
    const {
        minRows,
        ariaLabel,
        placeholder,
        maxRows,
        value,
        onChange,
        width,
        style,
        isDisabled,
    } = props;

    return (
        <StyledTextarea
            ref={ref}
            aria-label={ariaLabel}
            width={width}
            minRows={minRows}
            maxRows={maxRows}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={style}
            disabled={isDisabled}
        />
    );
});

TextArea.propTypes = {
    width: PropTypes.number,
    minRows: PropTypes.number,
    ariaLabel: PropTypes.string,
    placeholder: PropTypes.string,
    maxRows: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func,
    style: PropTypes.object,
    isDisabled: PropTypes.bool,
};

TextArea.defaultProps = {
    minRows: 3,
    ariaLabel: 'textarea',
    placeholder: 'Placeholder...',
    isDisabled: false,
};

export default TextArea;
